import type { Dispatch, SetStateAction } from "react";
import type { FormState } from "../types";
import type { Errors } from "../validation";
import { useQuoteCopy } from "../i18n/QuoteCopyContext";
import { TextArea, TextInput } from "./fields";

interface Props {
  form: FormState;
  setForm: Dispatch<SetStateAction<FormState>>;
  errors: Errors;
  onBlur: (id: string) => void;
}

export function ContactFields({ form, setForm, errors, onBlur }: Props) {
  const copy = useQuoteCopy();
  return (
    <>
      <div className="nv-row">
        <TextInput
          id="nv-contactName"
          label={copy.t("contact.name")}
          autoComplete="name"
          required
          error={errors.contactName}
          value={form.contactName}
          onChange={(v) => setForm((f) => ({ ...f, contactName: v }))}
          onBlur={() => onBlur("contactName")}
        />
        <TextInput
          id="nv-company"
          label={copy.t("contact.company")}
          autoComplete="organization"
          required
          error={errors.company}
          value={form.company}
          onChange={(v) => setForm((f) => ({ ...f, company: v }))}
          onBlur={() => onBlur("company")}
        />
      </div>
      <div className="nv-row">
        <TextInput
          id="nv-email"
          label={copy.t("contact.email")}
          type="text"
          autoComplete="email"
          required
          error={errors.email}
          value={form.email}
          onChange={(v) => setForm((f) => ({ ...f, email: v }))}
          onBlur={() => onBlur("email")}
        />
        <TextInput
          id="nv-phone"
          label={copy.t("contact.phone")}
          type="tel"
          autoComplete="tel"
          error={errors.phone}
          value={form.phone}
          onChange={(v) => setForm((f) => ({ ...f, phone: v }))}
          onBlur={() => onBlur("phone")}
        />
      </div>
      <TextArea
        id="nv-comment"
        label={copy.t("contact.comment")}
        rows={3}
        error={errors.comment}
        value={form.comment}
        onChange={(v) => setForm((f) => ({ ...f, comment: v }))}
      />
    </>
  );
}
